/* eslint-disable @typescript-eslint/no-unused-vars */
import { IRootState } from "../../../redux/root.reducer";
import { ITokenPair } from "../interface/dto/token-pair";

const ACCESS_TOKEN_KEY = "at";
const REFRESH_TOKEN_KEY = "rt";

export const setAuthTokens = (accessToken: string, refreshToken: string) => {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const deleteAuthTokens = () => {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
};

export const selectAuthTokens = (): ITokenPair => ({
    accessToken: sessionStorage.getItem(ACCESS_TOKEN_KEY) ?? undefined,
    refreshToken: sessionStorage.getItem(REFRESH_TOKEN_KEY) ?? undefined,
});

export const selectRefreshToken = (state: IRootState): ITokenPair => ({
    accessToken: sessionStorage.getItem(REFRESH_TOKEN_KEY) ?? undefined,
    refreshToken: sessionStorage.getItem(REFRESH_TOKEN_KEY) ?? undefined,
});
